import actionTypes from 'SRC/modules/redux/actionTypes'

export const resetBoughtItems = () => ({
  type: actionTypes.RESET_BOUGHT_ITEMS,
  payload: {}
})
